export function getProfileURI(username: string): string {
    return '/profile/' + encodeURIComponent(username)
}

// https://stackoverflow.com/questions/65436234
export function linkify(inputText: string): string {
    if(inputText.includes('<a')) return inputText

    // URLs starting with http://, https://, or ftp://
    const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim
    let replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>')

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    const replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>')

    // Change email addresses to mailto:: links.
    const replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>')
    return replacedText
}

export function stripOAuthTokenFromString(urlString: string): string {
    const newURL = new URL(urlString)
    newURL.searchParams.delete('token')
    return newURL.href
}

export function stripOAuthTokenFromUrl() {
    const newURL = stripOAuthTokenFromString(window.location.href)
    history.replaceState(null, '', newURL)
}
